class Common {
  constructor() {
    this.tvWindowMetrics = null
  }

  async _init() {
    const { width, height, left, top } = document.body.getBoundingClientRect()
    this.tvWindowMetrics = { el: null, index: false, width, height, x: left, y: top }

    return true
  }

  async tvWindowFront(save = false) {
    return this.tvWindowResize(this.tvWindowMetrics.el, true, save)
  }
  async tvWindowBehind(save = false) {
    return this.tvWindowResize(this.tvWindowMetrics.el, false, save)
  }
  async tvWindowResize(el = null, index = null, save = true) {
    try {
      let element = document.body

      if (el) {
        element = document.getElementById(el)
        if (!element || !element.offsetParent) element = document.body
        if (typeof index !== "boolean") index = true
      }

      const { width, height, left, top } = element.getBoundingClientRect()
      const position = { width, height, x: left || 0, y: top || 0 }
      if (!position.width) position.width = window.innerWidth
      if (!position.height) position.height = window.innerHeight

      if (save) this.tvWindowMetrics = { el, index, ...position }

      return this._tvWindowSetSize({ el, index, ...position }).finally(() => _$.vue.$emit("playerMetrics", { el, index, ...position }))
    } catch (err) {
      return _$.error(err)
    }
  }
  async _tvWindowSetSize(metrics) {
    let { width, height, x, y, index } = metrics || this.tvWindowMetrics

    return __._common.setTvWindowSize({ width, height, x, y, index }).catch(err => _$.error(err))
  }
}

export default new Common()
